import { AxiosResponse } from 'axios';
import promise from 'es6-promise';
import param from 'jquery-param';
import clientUtil from 'utils/clientUtil';
import { apiUrlUtil } from './apiUrlUtil';
promise.polyfill();

export const handleJsonResponse = async (response: {
  json: () => Promise<any>;
  status: number;
  ok: any;
}) => {
  return response
    .json()
    .catch((error: any) => {
      // In general we expect valid JSON responses but it is frequent for certain requests to return empty responses
      // To avoid making basic AJAX functions verbose and unergonomic to use we support them here

      // 204 is the only response we can consistently expect to be empty, the rest we log in case there is an actual error
      if (response.status !== 204) console.warn(error);

      return response;
    })
    .then((json: any) => ({ json, ok: response.ok }))
    .then(({ json, ok }) => {
      if (!ok) throw { json };
      return json;
    });
};

export const cleanParams = async (params: { [x: string]: any }) => {
  return Object.keys(params)
    .filter((key) => typeof params[key] !== 'undefined')
    .filter((key) => params[key] !== null)
    .filter((key) => params[key] !== '')
    .reduce((acc: { [key: string]: any }, key: string) => {
      const param = params[key];

      acc[key] = typeof !Array.isArray(param) && param == 'object' ? cleanParams(param) : param;

      return acc;
    }, {} as { [key: string]: any });
};

export const urlParams = async (params: any) => {
  return param(cleanParams(params));
};

const config = async (url: string, params = {}, configObj = {}) => ({
  data: params,
  url: `${apiUrlUtil()}${url}`,
  ...configObj
});

export const get = async (
  url: string,
  configObj: object | undefined,
  handleResponse?:
    | ((
        value: AxiosResponse<any, any>
      ) => AxiosResponse<any, any> | PromiseLike<AxiosResponse<any, any>>)
    | null
    | undefined
) => {
  const client = clientUtil();

  return client
    .request({
      method: 'GET',
      ...(await config(url, {}, configObj))
    })
    .then(handleResponse);
};

export const post = async (
  url: string,
  params: object | undefined,
  handleResponse?:
    | ((
        value: AxiosResponse<any, any>
      ) => AxiosResponse<any, any> | PromiseLike<AxiosResponse<any, any>>)
    | null
    | undefined
) => {
  const client = clientUtil();

  return client
    .request({
      method: 'POST',
      ...(await config(url, params))
    })
    .then(handleResponse);
};

export const patch = async (
  url: string,
  params: object | undefined,
  handleResponse:
    | ((
        value: AxiosResponse<any, any>
      ) => AxiosResponse<any, any> | PromiseLike<AxiosResponse<any, any>>)
    | null
    | undefined
) => {
  const client = clientUtil();

  return client
    .request({
      method: 'PATCH',
      ...(await config(url, params))
    })
    .then(handleResponse);
};

export const deleteRequest = async (
  url: string,
  handleResponse?:
    | ((
        value: AxiosResponse<any, any>
      ) => AxiosResponse<any, any> | PromiseLike<AxiosResponse<any, any>>)
    | null
) => {
  const client = clientUtil();

  return client
    .request({
      method: 'delete',
      ...(await config(url))
    })
    .then(handleResponse);
};
